<template>
  <div>
    <div class="row g-3">
      <div class="col-6 col-xl" v-for="c in cards" :key="c.key">
        <div class="big-card h-100">
          <span class="big-icon"><i :class="c.icon"></i></span>
          <div class="big-info">
            <span class="big-value">{{ numberBR(data[c.key]) }}</span>
            <span class="big-label">{{ c.label }}</span>
          </div>
        </div>
      </div>
    </div>

    <h6 class="text-muted mt-4 mb-3">Pamia (chatbot com IA)</h6>
    <div class="row g-3">
      <div class="col-6 col-xl-3" v-for="c in pamiaCards" :key="c.key">
        <div class="big-card h-100">
          <span class="big-icon"><i :class="c.icon"></i></span>
          <div class="big-info">
            <span class="big-value">{{ numberBR(data.pamia?.[c.key]) }}</span>
            <span class="big-label">{{ c.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { numberBR } from "@/utils/dashboardCharts";

export default {
  name: "DashBigNumbers",
  props: { data: { type: Object, required: true } },
  data() {
    return {
      cards: [
        {
          key: "psy_subscribers",
          label: "Psis assinantes",
          icon: "fa-solid fa-star",
        },
        {
          key: "patients",
          label: "Pacientes",
          icon: "fa-solid fa-user-group",
        },
        { key: "psys", label: "Psicólogos", icon: "fa-solid fa-user-doctor" },
        {
          key: "psys_approved",
          label: "Psis aprovados",
          icon: "fa-solid fa-user-check",
        },
        {
          key: "successful_appointments",
          label: "Sessões concluídas",
          icon: "fa-solid fa-calendar-check",
        },
      ],
      pamiaCards: [
        {
          key: "recommendations",
          label: "Recomendações",
          icon: "fa-solid fa-robot",
        },
        { key: "clicks", label: "Cliques", icon: "fa-solid fa-arrow-pointer" },
        {
          key: "appointments",
          label: "Sessões geradas",
          icon: "fa-solid fa-calendar-check",
        },
      ],
    };
  },
  methods: { numberBR },
};
</script>

<style scoped>
.big-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px;
  background-color: #fff;
  border: 1px solid #edf0f5;
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(18, 38, 63, 0.04);
}
.big-icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
  flex: 0 0 46px;
  background-color: rgba(251, 164, 134, 0.16);
  color: var(--bs-primary, #fba486);
}
.big-info {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
  min-width: 0;
}
.big-value {
  font-size: 1.7rem;
  font-weight: 800;
  color: #12263f;
  letter-spacing: -0.5px;
}
.big-label {
  font-size: 0.78rem;
  color: #8896a6;
  margin-top: 2px;
}
</style>
